module.exports = __webpack_public_path__ + "img/tuin_entree.dc2d3f80.png";